import { useState } from 'react';
import { useParams } from 'react-router-dom';
import { AnalystPrimaryContent, AnalystPrimaryStepper, CommonJobDetails } from './components';
import { useAnalystProjectView } from './hooks/useAnalystProjectView';

export default function AnalystProjectView() {
  const { projectId } = useParams();

  const { projectData, loading, primarySteps } = useAnalystProjectView(projectId);

  const [activeStep, setActiveStep] = useState(0);
  const handleStepClick = (stepIndex) => {
    const totalSteps = primarySteps.length;
    const newStep = stepIndex < 0 ? 0 : stepIndex >= totalSteps - 1 ? totalSteps - 1 : stepIndex;
    setActiveStep(newStep);
  };

  return (
    <>
      <CommonJobDetails loading={loading} projectData={projectData?.commonDetails} />
      <AnalystPrimaryStepper
        primarySteps={primarySteps}
        activeStep={activeStep}
        onStepClick={handleStepClick}
      />
      <AnalystPrimaryContent data={projectData} steps={primarySteps} activeStep={activeStep} />
    </>
  );
}
